import { Params } from '@angular/router';
import { Severity } from '../constants';
import { SystemEntity } from '@wdx/shared/swagger-gen';

export interface NotificationAlert {
    label: string | number;
    severity: Severity;
}

export interface InterpolationFragment {
    type: InterpolationFragmentType;
    value: string;
    entityType?: SystemEntity;
    entityId?: string;
    subEntityType?: string;
    subEntityId?: string;
    fileIndex?: string;
    routerLink?: string[];
    queryParams?: Params;
}

export enum InterpolationFragmentType {
    Text = 'Text',
    Link = 'Link',
    FileDownload = 'FileDownload',
}
